var _g, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgNervaAppIconBlack = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 101,
    viewBox: "0 0 101 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_5114_1737)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 20C3 9.50659 11.5066 1 22 1H79C89.4934 1 98 9.50659 98 20V77C98 87.4934 89.4934 96 79 96H22C11.5066 96 3 87.4934 3 77V20Z",
    fill: "black"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64.2097 55.8114C58.2817 59.4077 50.4502 58.6502 45.3324 53.5258C40.208 48.4014 39.4505 40.5765 43.0468 34.6485L30.8681 22.4697C18.2941 35.0437 18.2941 55.4228 30.8681 67.9967C43.442 80.5706 63.8211 80.5706 76.3951 67.9967L64.2163 55.818L64.2097 55.8114Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M75.3279 23.5322C69.3077 17.512 59.5529 17.512 53.5326 23.5322C52.6369 24.428 51.8728 25.4094 51.2471 26.4501C47.6508 32.3781 48.4082 40.2097 53.5326 45.3275C58.6571 50.4519 66.482 51.2094 72.41 47.6131C73.4507 46.9808 74.4321 46.2233 75.3279 45.3275C81.3481 39.3073 81.3481 29.5525 75.3279 23.5322Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5114_1737",
    x: 0,
    y: 0,
    width: 101,
    height: 101,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5114_1737"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5114_1737",
    result: "shape"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgNervaAppIconBlack);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/nervaAppIconBlack.7b2ed626e5e386d41ca1014c4b953937.svg";